export default __webpack_public_path__ + "static/media/Card-LatitudeInfinityRewardsVisa.1faeb3ca.png";